function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import tw from "tailwind-styled-components";
import { SInputV2 } from "../../SInputV2";
const _LengthInput = tw.input`

!outline-offset-0
appearance-none
shadow-none
rounded-md
!border
!border-white
!border-opacity-10
!outline-0

focus:!border-opacity-10

focus:!border-solid

focus:!border
focus:!border-white

focus:!outline-0
focus:!ring-0

px-3
w-full
text-white
text-[11px]  

py-1  
!bg-grayscale-light
`;
export const LengthInput = (props)=>{
    return(// <_LengthInput
    //   style={{
    //     ...props.style,
    //     lineHeight: "unset",
    //     boxShadow: "none",
    //     borderWidth: "1px",
    //     borderColor: "white",
    //   }}
    //   {...props}
    // />
    /*#__PURE__*/ _jsx(SInputV2, _object_spread({
        tabIndex: 1,
        className: `${props.className}`
    }, props)));
};
